const filterHeader = document.querySelector(".filter-header");
const filterOptions = document.querySelector(".filter-options");

if (filterHeader && filterOptions) {
  filterHeader.addEventListener("click", function () {
    filterOptions.classList.toggle("active");
  });
}
const swiper = new Swiper(".installation-process-slider", {
  slidesPerView: 1.1,
  spaceBetween: 20,
  freeMode: false,
  speed: 800, // Slide transition speed in ms
  pagination: {
    el: ".ips-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".ips-next",
    prevEl: ".ips-prev",
  },
  breakpoints: {
    750: {
      slidesPerView: 1.1,
    },
    992: {
      slidesPerView: 1.8,
    },
    1200: {
      slidesPerView: 2,
    },
  },
});

// ================================

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".still-looking-slider", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".ips-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".ips-next",
      prevEl: ".ips-prev",
    },
    breakpoints: {
      750: {
        slidesPerView: 1.5,
      },
      991: {
        slidesPerView: 2,
      },
    },
  });
});

let swipercps = null;
function initSwipercps() {
  const sliderEl = document.querySelector(".customer-projects-slider");
  if (!sliderEl) return;

  if (window.innerWidth <= 991) {
    if (!swipercps) {
      swipercps = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        freeMode: false,
        speed: 800,
        pagination: {
          el: ".cps-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".cps-next",
          prevEl: ".cps-prev",
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
        },
      });
    }
  } else {
    if (swipercps) {
      swipercps.destroy(true, true);
      swipercps = null;
    }
  }
}
window.addEventListener("DOMContentLoaded", initSwipercps);
window.addEventListener("resize", initSwipercps);
// =========================== //

const swipercpsTwo = new Swiper(".ag-state-slider", {
  slidesPerView: 1.15,
  spaceBetween: 20,
  freeMode: false,
  speed: 800,
  pagination: {
    el: ".ag-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".ag-next",
    prevEl: ".ag-prev",
  },
  breakpoints: {
    650: {
      slidesPerView: 2.15,
    },
    992: {
      slidesPerView: 2.3,
    },
    1200: {
      slidesPerView: 3,
    },
  },
});

// =========================== //

const swiperhcps = new Swiper(".home-customer-project-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  freeMode: false,
  speed: 800,
  pagination: {
    el: ".hcp-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".hcp-next",
    prevEl: ".hcp-prev",
  },
  breakpoints: {
    991: {
      slidesPerView: 1.2,
    },
    1200: {
      slidesPerView: 1.5,
    },
  },
});

// ================================
let swipercps2 = null;
function initSwipercps2() {
  const sliderE2 = document.querySelector(".together-slider");
  if (!sliderE2) return;

  if (window.innerWidth <= 991) {
    if (!swipercps2) {
      swipercps2 = new Swiper(sliderE2, {
        slidesPerView: 1.4,
        spaceBetween: 20,
        freeMode: false,
        speed: 800,
        pagination: {
          el: ".ts-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".ts-next",
          prevEl: ".ts-prev",
        },
        breakpoints: {
          750: {
            slidesPerView: 1.2,
          },
          992: {
            slidesPerView: 1.4,
          },
        },
      });
    }
  } else {
    if (swipercps) {
      swipercps.destroy(true, true);
      swipercps = null;
    }
  }
}
window.addEventListener("DOMContentLoaded", initSwipercps2);
window.addEventListener("resize", initSwipercps2);

// =========================== //

const vfsswiper = new Swiper(".view-full-slider", {
  slidesPerView: 1,
  spaceBetween: 0,
  freeMode: false,
  navigation: {
    nextEl: ".vfs-next",
    prevEl: ".vfs-prev",
  },
});

// const pmsswiper = new Swiper(".product-media-slider", {
//   slidesPerView: 1,
//   spaceBetween: 0,
//   freeMode: false,
//   pagination: {
//     el: ".pms__pagination",
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".pms-next",
//     prevEl: ".pms-prev",
//   },
// });
let pmsswiper = null;
const breakpoint = 992;
function initPMSSwiper() {
  const slider = document.querySelector('.product-media-slider');
  if (!slider) return; 
  if (window.innerWidth <= breakpoint && !pmsswiper) {
    pmsswiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: false,
      pagination: {
        el: slider.querySelector('.pms__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.pms-next'),
        prevEl: slider.querySelector('.pms-prev'),
      },
      observer: true,
      observeParents: true,
    });
  }
  if (window.innerWidth > breakpoint && pmsswiper) {
    pmsswiper.destroy(true, true);
    pmsswiper = null;
  }
}
document.addEventListener('DOMContentLoaded', initPMSSwiper);

window.addEventListener('resize', initPMSSwiper);




const productCardImgSlider = new Swiper(".product__card-img-slider", {
  slidesPerView: 1,
  spaceBetween: 0,
  freeMode: false,
  navigation: {
    nextEl: ".pcis-next",
    prevEl: ".pcis-prev",
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".case-stats-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".css-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".css-next",
      prevEl: ".css-prev",
    },
    breakpoints: {
      750: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    },
  });
});
// ==============  acccordion start  ============= //

const cattleYardsQuoteThumb = new Swiper(".cattle-yards-quote-thumbs", {
  spaceBetween: 20,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
});

const cattleYardsQuotes = new Swiper(".cattle-yards-quotes", {
  spaceBetween: 20,
  slidesPerView: 1,
  thumbs: {
    swiper: cattleYardsQuoteThumb,
  },
});

(function Accordion() {
  const triggers = document.querySelectorAll('[data-toggle="collapse"]');
  let activeToggle;
  triggers &&
    triggers.forEach((trigger) => {
      trigger.collapseTarget = document.querySelector(
        trigger.hash || trigger.dataset.target
      );

      trigger.collapseTarget.dataset.parent &&
        trigger.collapseTarget.classList.contains("is-active") &&
        (activeToggle = trigger);

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(trigger);
      });
      trigger.collapseTarget.addEventListener("transitionend", ({ target }) => {
        if (!target.classList.contains("is-active")) return;

        target.style.height = null;
      });
    });
  function toggle(trigger) {
    if (trigger.collapseTarget.classList.contains("is-active")) {
      close(trigger);
      activeToggle = null;
    } else {
      activeToggle &&
        activeToggle.collapseTarget.dataset.parent &&
        close(activeToggle);

      trigger.collapseTarget.dataset.parent && (activeToggle = trigger);

      open(trigger);
    }
  }
  function close(trigger) {
    setHeight(trigger.collapseTarget);

    trigger.parentElement.classList.remove("is-active");
    trigger.classList.remove("is-active");
    trigger.collapseTarget.classList.remove("is-active");

    setTimeout(() => {
      trigger.collapseTarget.style.height = null;
    }, 0);
  }
  function open(trigger) {
    trigger.classList.add("is-active");
    trigger.parentElement.classList.add("is-active");

    setTimeout(() => {
      setHeight(trigger.collapseTarget);
      trigger.collapseTarget.classList.add("is-active");
    }, 0);
  }
  function setHeight(target) {
    target.style.height = target.scrollHeight + "px";
  }
})();

// footer accordion script
document.addEventListener("DOMContentLoaded", function () {
  const footerBlocks = document.querySelectorAll(".footer-block");

  const updateAccordionBehavior = () => {
    const isMobile = window.innerWidth <= 991;

    footerBlocks.forEach((block) => {
      const heading = block.querySelector("h5");
      const detailsContent = block.querySelector("ul");

      // Ensure both heading and detailsContent exist
      if (heading && detailsContent) {
        if (isMobile) {
          // Mobile view: hide content and enable accordion
          if (!detailsContent.classList.contains("hidden")) {
            detailsContent.classList.add("hidden");
          }
          if (!heading.classList.contains("accordion-enabled")) {
            heading.classList.add("accordion-enabled");
            heading.addEventListener("click", toggleAccordion);
          }
        } else {
          // Desktop view: show content and remove accordion behavior
          detailsContent.classList.remove("hidden", "visible");
          heading.classList.remove("active", "accordion-enabled");
          heading.removeEventListener("click", toggleAccordion);
        }
      }
    });
  };

  const toggleAccordion = function () {
    const detailsContent = this.nextElementSibling;
    if (detailsContent) {
      const isOpen = detailsContent.classList.contains("hidden");
      detailsContent.classList.toggle("hidden", !isOpen);
      detailsContent.classList.toggle("visible", isOpen);
      this.classList.toggle("active", isOpen);
    }
  };

  // Initial setup and dynamic updates on resize
  updateAccordionBehavior();
  window.addEventListener("resize", updateAccordionBehavior);
});


// product saving collapsable 
document.addEventListener('click', function (e) {
  const openBtn = e.target.closest('.product-saving-btn');
  const closeBtn = e.target.closest('.product-saving-info-head');
  if (openBtn) {
    const parent = openBtn.closest('.product-savings');
    if (!parent) return;
    parent.classList.add('is-active');
  }
  if (closeBtn) {
    const parent = closeBtn.closest('.product-savings');
    if (!parent) return;
    parent.classList.remove('is-active');
  }
});


